// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Colors_container__BE7Bc {
  animation: Colors_init__rhJai 0.5s;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.Colors_title__Ujhpn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.5rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
}

.Colors_save__Z5AXh {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}
.Colors_Primarytitle__SKoMm {
  flex-direction: row;
}

.Colors_inputTitle__Fglow {
  margin-left: 20px;
}

.Colors_colors__\\+MgNe {
  padding-top: 30px;
  display: flex;
  width: 100%;
  justify-content: space-around;
}

.Colors_square__pAqZi {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 40%;
  background-color: white;
  border-radius: 10px;
  padding: 40px;
}

.Colors_colorsHeader__n0Mgo {
  display: flex;
}

.Colors_logos__9tbwU {
  margin-top: 30px;
  display: flex;
  width: 100%;
  justify-content: space-around;
  margin-bottom: 5vw;
}

.Colors_logo1__u\\+7Sb,
.Colors_logo2__ICh\\+- {
  width: 40%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  border-radius: 30px;
  padding: 40px;
}

.Colors_uploaders__JqL4Q {
  margin-top: 30px;
  display: flex;
  width: 100%;
  justify-content: space-around;
}

.Colors_uploader1__\\+WTCD,
.Colors_uploader2__RNyoH {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2vw;
}

.Colors_labelUpload__VPxrd {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  gap: 40px;
  transition: ease 0.5s;
}

.Colors_labelUpload__VPxrd:hover {
  transform: scale(1.05);
  transition: ease 0.5s;
}

.Colors_input1__3mq6M {
  display: none;
}

h1 {
  font-family: sans-serif;
  font-weight: 200;
}

h3 {
  font-family: sans-serif;
  font-weight: 200;
}
.Colors_paletsContainers__t7W-A {
  padding-top: 60px;
  display: flex;
  width: 100%;
  justify-content: space-around;
}

.Colors_paletsContainer__10Ycb {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-around;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 500px;
  width: 300px;
}

.Colors_buttonContainer__c8jLF {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  margin: 30px;
  width: 100%;
  height: 100%;
}

.Colors_imagePallete__Cn93w {
  width: 100%;
  height: auto;
}

.Colors_contenedorColors__0gTi6 {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-around;
}

.Colors_contenedorColor__f2\\+lD {
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 100%;
}

.Colors_primaryLogo__8y4AE {
  width: 15vw;
}

.Colors_printLogo__vmgqY {
  width: 7vw;
}

.Colors_itemDate__ckEAH {
  color: gray;
}

.Colors_validityInput__GVyQb {
  margin: 10px;
}

.Colors_dialogContainer__1AHLN .MuiDialog-paper {
  padding: 10px;
  border-radius: 5px;
}
.Colors_overflow__jjNAq {
  overflow: hidden;
}

.Colors_dialogContainer__1AHLN .Colors_paletteTitle__ozeud {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.Colors_dialogContainer__1AHLN .Colors_paletteTitle__ozeud .Colors_titleInput__Bedpe {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: -24px;
}

.Colors_dialogContainer__1AHLN .Colors_paletteTitle__ozeud .Colors_datesContainer__Xpnn6 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 10px;
}

.Colors_dialogContainer__1AHLN h3 {
  font-family: Roboto, sans-serif;
  font-weight: 300;
  font-size: 1.1rem;
  margin-bottom: 5px;
  margin-top: 0px;
}

.Colors_dialogContainer__1AHLN .Colors_paletteTitle__ozeud .Colors_datesInputs__YLSjK {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
}

.Colors_dialogContainer__1AHLN .Colors_paletteTitle__ozeud .Colors_datesInputs__YLSjK .Colors_dateInput__nv5MD {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 50%;
}

.Colors_dialogContainer__1AHLN .Colors_paletteTitle__ozeud .Colors_datesInputs__YLSjK .Colors_dateInput__nv5MD .Colors_selectDate__fumh6 {
  font-family: Roboto, sans-serif;
  font-size: 1rem;
  font-weight: 400;
  width: 80%;
  padding: 5px;
  height: 30px;
  border-radius: 10px;
  border: 1px solid rgba(94, 94, 94, 0.49);
}

.Colors_cardColor__bJzun {
  height: 400px;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0 0 30px -3px rgba(0, 0, 0, 0.2);
}

.Colors_cardColor__bJzun h4 {
  display: flex;
  flex-direction: column;
  text-align: center;
  font-size: 1.2rem;
  margin: 0 0 20px;
  font-weight: 400;
  font-family: Roboto, sans-serif;
}

.Colors_cardColorSelected__z8crD {
  border: 3px solid;
}

/*---Información---*/

.Colors_container__BE7Bc .Colors_dataContainer__fjMIQ {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 500px;
}

.Colors_container__BE7Bc .Colors_dataContainer__fjMIQ .Colors_tableContainer__GnRAX {
  animation: Colors_init__rhJai 1s;
  margin-top: 50px;
  margin-bottom: 50px;
}

.Colors_container__BE7Bc .Colors_dataContainer__fjMIQ .Colors_tableContainer__GnRAX {
  border-radius: 10px;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.Colors_container__BE7Bc .Colors_dataContainer__fjMIQ .Colors_tableContainer__GnRAX .Colors_iconbtn__L4db4 {
  transition: 0.3s;
  font-size: 1.8rem;
}

.Colors_container__BE7Bc .Colors_dataContainer__fjMIQ .Colors_tableContainer__GnRAX .Colors_iconbtn__L4db4:hover {
  transition: 0.3s;
  cursor: pointer;
  filter: brightness(0.7);
  scale: 1.1;
}

@keyframes Colors_init__rhJai {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Colors/index.module.css"],"names":[],"mappings":"AAAA;EACE,kCAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;AACnB;;AAEA,oBAAoB;;AAEpB;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,gCAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".container {\n  animation: init 0.5s;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.title {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 1.5rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n}\n\n.save {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 20px;\n}\n.Primarytitle {\n  flex-direction: row;\n}\n\n.inputTitle {\n  margin-left: 20px;\n}\n\n.colors {\n  padding-top: 30px;\n  display: flex;\n  width: 100%;\n  justify-content: space-around;\n}\n\n.square {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  width: 40%;\n  background-color: white;\n  border-radius: 10px;\n  padding: 40px;\n}\n\n.colorsHeader {\n  display: flex;\n}\n\n.logos {\n  margin-top: 30px;\n  display: flex;\n  width: 100%;\n  justify-content: space-around;\n  margin-bottom: 5vw;\n}\n\n.logo1,\n.logo2 {\n  width: 40%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: white;\n  border-radius: 30px;\n  padding: 40px;\n}\n\n.uploaders {\n  margin-top: 30px;\n  display: flex;\n  width: 100%;\n  justify-content: space-around;\n}\n\n.uploader1,\n.uploader2 {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 2vw;\n}\n\n.labelUpload {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  gap: 40px;\n  transition: ease 0.5s;\n}\n\n.labelUpload:hover {\n  transform: scale(1.05);\n  transition: ease 0.5s;\n}\n\n.input1 {\n  display: none;\n}\n\nh1 {\n  font-family: sans-serif;\n  font-weight: 200;\n}\n\nh3 {\n  font-family: sans-serif;\n  font-weight: 200;\n}\n.paletsContainers {\n  padding-top: 60px;\n  display: flex;\n  width: 100%;\n  justify-content: space-around;\n}\n\n.paletsContainer {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  height: 500px;\n  width: 300px;\n}\n\n.buttonContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  text-align: center;\n  margin: 30px;\n  width: 100%;\n  height: 100%;\n}\n\n.imagePallete {\n  width: 100%;\n  height: auto;\n}\n\n.contenedorColors {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  justify-content: space-around;\n}\n\n.contenedorColor {\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  width: 100%;\n}\n\n.primaryLogo {\n  width: 15vw;\n}\n\n.printLogo {\n  width: 7vw;\n}\n\n.itemDate {\n  color: gray;\n}\n\n.validityInput {\n  margin: 10px;\n}\n\n.dialogContainer :global .MuiDialog-paper {\n  padding: 10px;\n  border-radius: 5px;\n}\n.overflow {\n  overflow: hidden;\n}\n\n.dialogContainer .paletteTitle {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.dialogContainer .paletteTitle .titleInput {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin: -24px;\n}\n\n.dialogContainer .paletteTitle .datesContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.dialogContainer h3 {\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  font-size: 1.1rem;\n  margin-bottom: 5px;\n  margin-top: 0px;\n}\n\n.dialogContainer .paletteTitle .datesInputs {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  width: 100%;\n}\n\n.dialogContainer .paletteTitle .datesInputs .dateInput {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  width: 50%;\n}\n\n.dialogContainer .paletteTitle .datesInputs .dateInput .selectDate {\n  font-family: Roboto, sans-serif;\n  font-size: 1rem;\n  font-weight: 400;\n  width: 80%;\n  padding: 5px;\n  height: 30px;\n  border-radius: 10px;\n  border: 1px solid rgba(94, 94, 94, 0.49);\n}\n\n.cardColor {\n  height: 400px;\n  padding: 10px;\n  border-radius: 10px;\n  box-shadow: 0 0 30px -3px rgba(0, 0, 0, 0.2);\n}\n\n.cardColor h4 {\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  font-size: 1.2rem;\n  margin: 0 0 20px;\n  font-weight: 400;\n  font-family: Roboto, sans-serif;\n}\n\n.cardColorSelected {\n  border: 3px solid;\n}\n\n/*---Información---*/\n\n.container .dataContainer {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  min-height: 500px;\n}\n\n.container .dataContainer .tableContainer {\n  animation: init 1s;\n  margin-top: 50px;\n  margin-bottom: 50px;\n}\n\n.container .dataContainer .tableContainer {\n  border-radius: 10px;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.container .dataContainer .tableContainer .iconbtn {\n  transition: 0.3s;\n  font-size: 1.8rem;\n}\n\n.container .dataContainer .tableContainer .iconbtn:hover {\n  transition: 0.3s;\n  cursor: pointer;\n  filter: brightness(0.7);\n  scale: 1.1;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Colors_container__BE7Bc`,
	"init": `Colors_init__rhJai`,
	"title": `Colors_title__Ujhpn`,
	"save": `Colors_save__Z5AXh`,
	"Primarytitle": `Colors_Primarytitle__SKoMm`,
	"inputTitle": `Colors_inputTitle__Fglow`,
	"colors": `Colors_colors__+MgNe`,
	"square": `Colors_square__pAqZi`,
	"colorsHeader": `Colors_colorsHeader__n0Mgo`,
	"logos": `Colors_logos__9tbwU`,
	"logo1": `Colors_logo1__u+7Sb`,
	"logo2": `Colors_logo2__ICh+-`,
	"uploaders": `Colors_uploaders__JqL4Q`,
	"uploader1": `Colors_uploader1__+WTCD`,
	"uploader2": `Colors_uploader2__RNyoH`,
	"labelUpload": `Colors_labelUpload__VPxrd`,
	"input1": `Colors_input1__3mq6M`,
	"paletsContainers": `Colors_paletsContainers__t7W-A`,
	"paletsContainer": `Colors_paletsContainer__10Ycb`,
	"buttonContainer": `Colors_buttonContainer__c8jLF`,
	"imagePallete": `Colors_imagePallete__Cn93w`,
	"contenedorColors": `Colors_contenedorColors__0gTi6`,
	"contenedorColor": `Colors_contenedorColor__f2+lD`,
	"primaryLogo": `Colors_primaryLogo__8y4AE`,
	"printLogo": `Colors_printLogo__vmgqY`,
	"itemDate": `Colors_itemDate__ckEAH`,
	"validityInput": `Colors_validityInput__GVyQb`,
	"dialogContainer": `Colors_dialogContainer__1AHLN`,
	"overflow": `Colors_overflow__jjNAq`,
	"paletteTitle": `Colors_paletteTitle__ozeud`,
	"titleInput": `Colors_titleInput__Bedpe`,
	"datesContainer": `Colors_datesContainer__Xpnn6`,
	"datesInputs": `Colors_datesInputs__YLSjK`,
	"dateInput": `Colors_dateInput__nv5MD`,
	"selectDate": `Colors_selectDate__fumh6`,
	"cardColor": `Colors_cardColor__bJzun`,
	"cardColorSelected": `Colors_cardColorSelected__z8crD`,
	"dataContainer": `Colors_dataContainer__fjMIQ`,
	"tableContainer": `Colors_tableContainer__GnRAX`,
	"iconbtn": `Colors_iconbtn__L4db4`
};
export default ___CSS_LOADER_EXPORT___;
